@if (embedData) {
  <div class="relative h-full flex flex-row justify-start items-center">
    <button mat-icon-button [routerLink]="['/my-embed']">
      <mat-icon class="text-gray-800">arrow_back_ios</mat-icon>
    </button>
  </div>
  <div class="relative flex flex-row gap-2 justify-start items-center">
    @if (!isTitleChange) {
      <p class="text-xl lg:text-2xl text-black dark:text-white" [innerText]="embedData.title"></p>
      <button mat-icon-button (click)="onClickTitleChangeBtn()">
        <mat-icon class="text-gray-800 text-base">edit</mat-icon>
      </button>
    } @else {
      <input
        class="text-gray-800 px-6 py-2 text-xl lg:text-2xl dark:text-white bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        type="text"
        [(ngModel)]="embedData.title"
        (keydown.enter)="onCompleteTitleChange()"
      />
    }
  </div>
  <div>
    <button mat-icon-button>
      <mat-icon class="text-gray-800">menu</mat-icon>
    </button>
  </div>
} @else {}
